// extracted by mini-css-extract-plugin
export default {"searchWrapper":"cjTemplateId_searchWrapper__6z1Bk"};